/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ScheduleReport = 0 | 1 | 2;

export const ScheduleReport = {

    NUMBER_0: 0 as ScheduleReport,

    NUMBER_1: 1 as ScheduleReport,

    NUMBER_2: 2 as ScheduleReport
};

